import React, { useEffect, useState } from 'react'
import { StyleSheet, Text, View, TouchableOpacity, Image } from 'react-native'
import { FormContentsModel, ModelAnswerFromProps } from '../models/StoreDetailModel'
import { SiNoNaButton } from './SiNoNaItem'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../../navigation/stacks/NavigationStack'
import { schedulesServices } from '../../../../database/schedules.database'
import { useBottomSheet } from '../../customUtils/context/BottomSheetContext'
import { fetchAuthSession } from 'aws-amplify/auth'
import { request_save_form } from '../../../services/schedule.services'
import { useFormRefrigeratorContext, useFormContext } from '../context/form.context'
import theme from '../../../../theme'
import styles from './InputFormItemStyles'
import { getLanguage } from '../../appBar/context/LocalizationContext'
import { ImageWithZoom } from '../../customUtils/Components/ImageWIthZoom'
import { PATH_ASSETS } from '../../../utils/Constants'
import useImageLoader from '../../../hooks/useImageLoader'
import { Loader } from '../../customUtils/Components/Loader'

interface InputFormItemI {
    item: FormContentsModel
    form_id: string
    schedule_id: string
    store_id: string
    checkComplete: (option?: ModelAnswerFromProps) => void
    checkin_id: string
}

export const InputFormItem = React.memo(({ item, form_id, schedule_id, store_id, checkComplete, checkin_id }: InputFormItemI) => {
    const navigation = useNavigation<StackNavigationProp<DotsNavigation>>()
    const { form_refrigerators_main, getFormRefrigerator, updateActveFormRefrigerator, reloadActive, deleteQuestionForm } =
        useFormRefrigeratorContext()
    const { currentCheckin } = useFormContext()
    const { formQuestions } = getFormRefrigerator(form_refrigerators_main, form_id)
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const [selectedIndex, setSelectedIndex] = useState(-1)
    const [active, setActive] = useState(true)
    const { image, loading, placeholderGeneral } = useImageLoader(item.media, PATH_ASSETS)
    const [preview, setPreview] = useState(image)

    useEffect(() => {
        setPreview(image)
    }, [image])
    useEffect(() => {
        if (formQuestions && formQuestions.length > 0) {
            const findIndex = formQuestions.findIndex((quest) => quest._id === item._id)
            if (findIndex !== -1) {
                setActive(formQuestions[findIndex]['active'] ?? true)

                if (formQuestions[findIndex]['active'] && !formQuestions[findIndex]['index']) {
                    setSelectedIndex(-1)
                }

                if (!formQuestions[findIndex]['active']) {
                    if (formQuestions[findIndex]['index']) {
                        setSelectedIndex(formQuestions[findIndex]['index'])
                    } else {
                        setSelectedIndex(0)
                    }
                }
            }
        }
    }, [item, reloadActive])

    const handleQuestion = async (index: number) => {
        // if (index === selectedIndex) {
        //     return
        // }
        // setSelectedIndex(index)

        const action = item.secondary_actions[index]

        let answer: ModelAnswerFromProps = {
            _id: item._id,
            option_selected_text: [item.secondary_actions[index].label],
            option_selected_id: [item.secondary_actions[index]._id],
            question_id: item._id,
            media: '',
            question_text: item.title,
            score: item.secondary_actions[index].score ? item.secondary_actions[index].score.toString() : '0',
            status: 1,
            date_finish: new Date().toString(),
            date_init: new Date().toString(),
            question_input: '',
            index: index,
            field_media: '',
            field_text: '',
            questionScore: item.questionScore,
            type: item.input_type.type,
            ponderar: item.questionScore && item.questionScore > 0, // [7, 8, 14, 18].includes(item.input_type.type),

            question: item.title,
            questionOptionSelected: [item.secondary_actions[index]._id],
            questionOptionSelectedText: [item.secondary_actions[index].label],
            questionType: {
                title: item.input_type.title,
                type: item.input_type.type,
                id: item.input_type._id,
            },
            questionPrice: '',
            description: '',
            tag: '',
            questionImage: '',
            questionInput: '',
        }

        if (action.refrigerator_id) {
            answer.refrigerator_id = action.refrigerator_id
        }

        if (action && action['form'] && action['form'].length > 0) {
            await schedulesServices.updateFormAnswerSchedule(answer, schedule_id, form_id, store_id)

            await checkComplete(answer)
            setSelectedIndex(index)
            console.log('Esta es mi heladera', action['form'])
            navigation.push('ExecutionView', {
                forms: action['form'],
                selectedIndex: 0,
                schedule_id: schedule_id,
                store_id: store_id,
                storeInfo: null,
                checkin_id: null,
            })
        } else {
            openBottomSheet(
                <AlertSentAnswer
                    closeBottomSheet={closeBottomSheet}
                    button
                    title={'¿Deseas eliminar la heladera?'}
                    desc={'Si confirmas, la heladera quedará desvinculada de esta tienda.'}
                    fnButtonCancel={() => fnButtonCancel(index, answer)}
                />,
            )
        }
    }

    const fnButtonCancel = async (index: number, answer: ModelAnswerFromProps) => {
        try {
            setSelectedIndex(index)

            const remplaceAnswers = true

            await schedulesServices.updateFormAnswerSchedule(answer, schedule_id, form_id, store_id, remplaceAnswers)
            await checkComplete(answer)

            const session = await fetchAuthSession()
            const authToken = session.tokens?.accessToken?.toString() || ""
            let dif_utc = -new Date().getTimezoneOffset() / 60
            const { answers, date_init, progress_questions_yes_na, heladera, create_refrigerator, type_form, form_id_father } =
                await schedulesServices.getFormsAnswers(schedule_id, form_id, store_id)

            let obj_json_raw = {
                answers: answers,
                date_finish: new Date().toISOString(),
                date_init: date_init,
                id_activity: form_id,
                status: 0,
                progress: progress_questions_yes_na,
                score: progress_questions_yes_na,
                heladera: heladera,
                create_refrigerator: create_refrigerator,
                input_type: type_form['type'],
            }

            if (form_id_father !== '') {
                obj_json_raw.id_activity = form_id_father
            }

            let json_raw = [obj_json_raw]

            let data_checkin_id

            if (!checkin_id && store_id) {
                // si no existe lo busco en local

                const checkin = await schedulesServices.get_checkin(store_id, schedule_id)
                if (checkin && checkin.length > 0) {
                    const index = checkin.length - 1
                    data_checkin_id = checkin[index].checkin_id
                } else {
                    data_checkin_id = currentCheckin
                }
            } else {
                data_checkin_id = checkin_id ?? currentCheckin
            }

            const data = {
                authToken: authToken,
                body: {
                    form: JSON.stringify(json_raw),
                    process_now: true,
                    date: new Date().toISOString(),
                    schedule_id: schedule_id,
                    checkin_id: data_checkin_id,
                    dif_utc: dif_utc.toString(),
                },
            }
            const res = await request_save_form(data)

            if (res && res.status && res.response.status) {
                const remplaceAnswers = true
                const clearAnswers = true
                await schedulesServices.updateFormAnswerSchedule(null, schedule_id, form_id, store_id, remplaceAnswers, clearAnswers)
                const active = false
                updateActveFormRefrigerator(form_refrigerators_main, form_id, item._id, active, index)
            }

            closeBottomSheet(true)
        } catch (error) {
            console.error('173 ---- fnButtonCancel: ERROR => ', error)
            throw new Error(error)
        }
    }
    const openBigImage = () => {
        if (image) {
            openBottomSheet(<ImageWithZoom uri={image} contentSeen={() => {}} path={''} />, undefined, undefined, true, true, true)
        }
    }
    return (
        <View style={!active ? styles.containerInactive : styles.containerActive}>
            <View style={styles.container}>
                {item.media && (
                    <TouchableOpacity onPress={() => openBigImage()}>
                        {loading ? (
                            <Loader />
                        ) : (
                            <Image
                                style={styles.image}
                                source={{ uri: preview }}
                                onError={(e) => {
                                    setPreview(placeholderGeneral)
                                }}
                            />
                        )}
                    </TouchableOpacity>
                )}
                <View>
                    {item.title && <Text style={styles.itemText}>{item.title}</Text>}
                    {item.description && <Text style={styles.itemText}>{item.description}</Text>}
                </View>

                <View style={styles.container} />

                <View>
                    <View style={styles.flexDirectionRow}>
                        {item.secondary_actions &&
                            item.secondary_actions.map((action, index) => {
                                const isSelected = selectedIndex === index

                                return (
                                    <SiNoNaButton
                                        key={action._id.toString()}
                                        name={action.label}
                                        index={index}
                                        onClickTag={!active ? () => {} : () => handleQuestion(index)}
                                        isSelected={isSelected}
                                    />
                                )
                            })}
                    </View>
                </View>
            </View>
            <View style={styles.dividerHorizontalLine}></View>
        </View>
    )
})

interface AlertSentAnswerI {
    button: boolean
    closeBottomSheet: (l) => void
    title: string
    desc: string
    fnButtonCancel: () => Promise<void>
}

export const AlertSentAnswer = ({ button = false, closeBottomSheet, title, desc, fnButtonCancel }: AlertSentAnswerI) => {
    const { languageFile } = getLanguage()

    const handleConfirm = async () => {
        await fnButtonCancel()
    }

    const handleCancel = () => {
        try {
            closeBottomSheet(true)
        } catch (error) {
            console.error('233 ---- handleCancel: ERROR => ', error)
        }
    }

    return (
        <View style={styles.contentContainer}>
            <View style={styles.messageContainer}>
                <View>
                    <Image style={styles.imageAsset} source={require('../../../../assets/stores/refrigeratorRemoved.png')} resizeMode='contain' />
                </View>
                <Text style={styles.titleText}>{title}</Text>
                <Text style={styles.descriptionText}>{desc}</Text>
            </View>

            <View style={styles.spacer} />

            <View style={styles.containerButton}>
                <TouchableOpacity style={styles.mainButton} onPress={handleConfirm}>
                    <Text style={styles.mainButtonText}>{languageFile.confirm}</Text>
                </TouchableOpacity>

                {button && (
                    <TouchableOpacity style={styles.secondaryButton} onPress={handleCancel}>
                        <Text style={styles.secondaryButtonText}>{languageFile.cancel}</Text>
                    </TouchableOpacity>
                )}
            </View>
        </View>
    )
}
